<template>
  <div class="pay" style="margin-top:100px!important;">
    <el-card class="pay__content">
      <avue-form :option="option"
                 v-model="form"
                 ref="form"
                 @submit="handleSubmit">
        <template slot-scope="{}"
                  slot="default">
          <div class="pay__title">
            <img
              src="data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAB0AAAAaCAYAAABLlle3AAADt0lEQVR4XrWWX2hcRRTGf2fu3XSTpqEbK5qmtAhqxaBKDagFpVAJ2LwIWAUriFgVVUFELKAKVfBRX1RAQEC0BMFH0RcLJQj4IraIapWoaZptUrKJxqb7584cQ5hhNnu5u1Twg8MZuLPz2+98c9mVO55RANLb6gBkp8v0FkKUcoUyXJkEMMme5liyp/WhGclG/Rnyf0HFAxKMfIDjKOhxIPFQ+a9Q6QFNkl2tu1DuUQWQR2S7G43gQkkO6rMMeUoXlymJHlMLuI0qS6IvAWkXt1LkVACT3lp/dr1eBJKYVXRpRrM7UZlkAyjgAHhK+t0u7zYfBbwKHG4/z2zaIDyP8E56S/3dAI5FIqm+gQIqhK6OLaT6Sm6/MAhMAW8BR9qzN9ExKcq3KAAvpDc3PvHgxGd5ryoH1AG+1II6QOUJ6dMRP+bE9y+BBwGAH6IJ79RXipUL4EenPJTsbXwElIA+DI8Fd6JgLaw1QFRAEYw+CpQwWsHwBcp+ov70uZtcpppxHgUUdKPLkeS65nvmansjMBFydJnQbAqTtwvXDkG9AagcxuhuhBMoB9mspcCK0ABuyQJOPNCPER6XAXdSLcM4EIXFFTi0Dnz4bsP8EqQiqDKGMI3KQZR2NYGLgEQocYs2zAJKA4VYAsoQKhhgZRV2VuC5CcMv5+GPBRAFAUFlGEenasB84AQowZf+bebVsYxKfCUcqHd4uQ5ZJrz2gGH3Djj9u1IZEFIDagElJ+/yUrDQCVVdNf/gWIou46idhbU6HD1gmNwnzNfg/n3w2THh0LiwuCxF0HPhvgdOGhbhAY45YAwHsYTlVZgYMzx9n3BhBdaaMH6DIMBMVelLhAJVPTDnNIKtmQsg9R0LAyWhWoOXP3Y8+b7j51kYLMObJ5ST3wuVQYo0G6H526ve6ay/PO21DoXfqvDVd/DTLIxcBd/8CJ9PC5WtgHaFajenqi3mcESXvlsL5RS2lmD8+g0Qb08p1kJ/qRuTc72dtmRG869MKAywdydMnVLOzMDwNnDFxJqHds/UXUzP0uJTrHfZ4XpbWTh1hvWxwo4hwVCoS8Bx4K9OpylRDrBAy1VLr8t2Oy3CflVuwso1OPpxkhowtVWMqEhfgqojC58DFoEZ4CzwNfArhOcRHP6YASRACdgCDAD9fp3mfls3Szun5b9AA7gMrPl15sE5pxkgvhzQBEoRmgOSAwZoBLe6jVcjGPU9/D5KbyhEKNaXH20RNIJte75Fo+054gCKnW5QDePNwQozzZ8R13n9Cx1eymjGjLG7AAAAAElFTkSuQmCC">
            <span>选择授权</span>
          </div>
        </template>
        <template slot-scope="{}" slot="name">
          <h2 class="pay__name">BladeX商业授权—{{form.name}}</h2>
        </template>
        <template slot-scope="{}" slot="version">
          <div class="pay__list">
            <div class="pay__item"
                 v-for="(item,index) in config"
                 :key="index"
                 @click="handleSelect(item)"
                 :class="{'pay__item--active':form.version===item.value}">
              <div class="pay__item-name">
                <template v-if="item.value === 1">
                  {{ item.label }} <el-link type="primary" href="https://saber3.bladex.cn" >(查看演示)</el-link>
                </template>
                <template v-else-if="item.value === 3">
                  {{ item.label }} (数据大屏+企业版)
                </template>
                <template v-else-if="item.value === 5">
                  {{ item.label }} <el-link type="primary" href="https://data.bladex.cn" >(查看演示)</el-link>
                </template>
                <template v-else-if="item.value === 6">
                  {{ item.label }} <el-link type="primary" href="https://iot.bladex.cn/license.html" >(查看详情)</el-link>
                </template>
                <template v-else-if="item.value === 8">
                  {{ item.label }} <el-link type="primary" href="https://aigc.bladex.cn" >(查看演示)</el-link>
                </template>
                <template v-else-if="item.value === 9">
                  {{ item.label }} (大模型+企业版)
                </template>
                <template v-else-if="item.value === 10">
                  {{ item.label }} (数据大屏+物联网+大模型+企业版)
                </template>
                <template v-else>
                  {{ item.label }}
                </template>
              </div>
              <div class="pay__item-money">
                <span>¥</span>
                {{item.money}}
              </div>
              <img v-if="form.version===item.value"
                   class="pay__item-img"
                   src="/images/jiaobiao.png">
            </div>
          </div>
        </template>
        <template slot-scope="{}" slot="defaults">
          <h2 style="font-size: 22px;color: #409eff;">
            <span style="cursor: pointer;" @click="handleBox">点击我阅读(采购多份请联系商务对接)</span>
          </h2>
        </template>
        <template slot-scope="{}" slot="tickets">
          <span style="cursor: pointer;" ><el-tag effect="plain"><span @click="openTicket()">增值税普通电子发票</span></el-tag></span>
        </template>
        <template slot-scope="{}" slot="contact">
          <span style="cursor: pointer;" ><el-tag effect="plain"><span @click="openWX()">商务微信</span></el-tag></span>
        </template>
        <template slot-scope="{}" slot="introduction">
          <span style="cursor: pointer;">
            下单后会将授权资料发送至
            <span style="color: #3369ff;">
              {{
                user === 'bladex' && form.qq.includes('@')
                  ? form.qq
                  : (form.qq === ''
                    ? 'QQ邮箱'
                    : `${form.qq}@qq.com`)
              }}
            </span>，注意查收
          </span>
        </template>
        <template slot-scope="{}"
                  slot="money">
          <div class="pay__title"><img
            src="data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABYAAAAXCAMAAAA4Nk+sAAACZ1BMVEU2kPgzaf82kPg0dP03lPg2kPg2kPg2kPg3mPc2kPg2kPg2kPg2kPg2kPg2kPg2kPg2kPg3lfc2kPg2kPg2kPg2kPg2kPg3l/c2kPg2kPg2kPg2kPgzaf82kPgzaf8zaf82kPg1e/wzav82kPg2jvk2jvk1hfo3k/g2kvg0efw3k/g3k/g3lfc0dP01gvs0df03lPg2h/o3mPc0df00cv4zbv4zbP83lfc1fvszaf83mPc1g/s0d/03l/c3lPg2kPgzaf82ivk2h/o3lPg1gfszbP81ffw0cv43lfc3k/g2kPg2jfk2h/o1hPo1gfszaf8zaf80cP42kPg2h/o1hfo1gfs1hfo0e/w1hPo0eP01ffw0evwzbv82jPk0df01f/s2jvk2jPkzav81fvs0b/4zaf82jfk1gfs2jPk1iPo0d/01fPw2j/g2jvkzbv41h/o0eP01e/w0cf4zcP40cv42i/k1hvo2j/g0e/w2jfkzbf81hPozaf8za/82kPg2ifo1hfo0ef0zbP8zbf42jfk1iPo1f/s2kPgzaf81gPszaf8zbv41iPk0evw0d/0zbv4zbP8zaf8zaf80cP41fvs0e/w1fvw0efw0dv00c/00cP4zbf4za/8zav80dv0zbP4zaf83lvc3lPgzaf81gvs0df02kfg2kvg2i/k0cP41f/s2ifk1fPw1g/s1hfo2iPo0efw1hvo2j/g0c/00cv4za/8zav81ffw0dP01e/wzbf41gfs2jPk2kPg1fvs0d/00cf40b/42jfk2ivk2h/o1hPo0evw0eP02jvk0dv03lvczbv43lPi6h+BDAAAAo3RSTlMAABQAAAcDAQAaCRsEGQsWEgAVDREGAgAXDA4Q9Qrz8hMAAAWpAAAATIDO8c4RJlTeUW+7qKzNBPOFzg/Sz5mw0LfSXs4AbgA30WozAM9QfhxV/ppn9oV60N3O0IMdEPXeG87U4fiGGrU5/tYc8t4hagL9bK+OO1TYHOEj9qgIcSrS24OoVS8P7Q/8aC3bvM3Bwc9K9yGB8/Ly8/Py0uGV8RV8quAzBAAAAbJJREFUeF5Vz1Vz20AUhuFj2o1kyVJEkcxp0jbMWGRmZmZmZmZmhjWFGcuMPyqSPHYn7+x388zeHEhJSTWaNHkKTCuePiPdyGLROU1Xe1Ekc+CgBaGq3f14bLR1OcDQlfXZNpvNkuDK3PcbEMZowo8t+f/ZPiKy3e1DCu1eHN43cUCCB2cdnMqJCGlCQeHs8XEuGZ6XM/Lc6DGLxi1ZOqy0rLxizahqnYf8+Rf5FWtqDH3o+Rlu/9zbQcgrC8DrN9HWd3UtDbX1zb/bagydOQsAo4w5X77OnTe/a+Gu7j17l3USsgJhQD5pVaxpNb+2h+fb1/H8euLdqDHAiNymupbN1Nbmbc6aHdROL3muXmRAcXj2f/t+gD308TD79wh79Bg57jmhAGD6ZGPolHQ6LEm9ZzySl5ylMejJ5xtqL9Av2mi64xJ9+Qq56gCjjGtvu67f6P5081YnuX2HkLuyyYz7XuIQs/uMyUh88PDR4ydPnwX8/kDA/9KNTFZcqiq6BM7l4gR9qhZnTHOUYGVZqzGBUn0KmMlBykk5nZQ+/VkdOM5I463JgiID8TCSHclkxvjcB/q7gATqiPsDAAAAAElFTkSuQmCC">
            <span>购买方式/填写信息</span>
          </div>
        </template>

        <template slot-scope="{}" slot="type">
          <div style="display:flex;align-items:center">
<!--            <img v-if="form.version===1||form.version===3||form.version===5" src="/images/wxicon.png" alt="" width="40" />
            &nbsp; &nbsp;
            <el-radio v-if="form.version===1||form.version===3||form.version===5" v-model="form.type" :label="1">
              微信支付
            </el-radio>-->
            <img v-if="form.version===1||form.version===3||form.version===5||form.version===6||form.version===8||form.version===9||form.version===10" src="/images/zgyhicon.png" alt="" width="40"/>
            &nbsp; &nbsp;
            <el-radio v-if="form.version===1||form.version===3||form.version===5||form.version===6||form.version===8||form.version===9||form.version===10" v-model="form.type" :label="2">
              对公支付
            </el-radio>
          </div>
        </template>
      </avue-form>
    </el-card>
    <div class="pay__footer">
      <div class="pay__footer-box">
        <div class="pay__footer-name">
          <img
            src="data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABUAAAAUCAMAAABVlYYBAAABTVBMVEU2kPg2kPg2kPg2kPg2kPg2kPg2kPg2kPg2kPg2kPg3l/f///81hPo1g/s1f/s1gfs3mPc1gfsza/81gfs0cP4za/81fvs1gvo1gfs2jPk2i/k1f/s2jfk2ifo0d/02iPo1gvs1e/w1hvo2ivk1gPs1fPw2jvk1ffw3lPg0ePw1fvs3lvc0c/2UwvyTvP2UxPuTuv2UwPw0cf6Uxfs0efw0cP5dmfw1hfo0dv0zbv41g/s0dP02kPg0evw2kfg3k/g1hPo2h/o0df00cv02kvhepfpepfldl/2Uw/w2j/kzbP6Uxvs3lfczbf5eofteofo3kvhepPo0cv5dlf01fvw3lfiUv/xdm/xdnPxdnftdnvszb/5TkPxeovo2hvqTvvyWuv2ewf01g/o0b/7///9dlv1en/szbP+Tu/2Uwfzh7P6Tvfxdkf1dk/1dlP3TiYzGAAAAGHRSTlMcBxUFAxIBABoK5gDmSQDmSQDo6Vnq51lcC3P7AAABB0lEQVR4XnXPVW/DMBSGYSd2UhxTmFNmZhozMzPv/1/uNFI0tdu+y0ev5GM0MRI0uqop8KHVRmunHdmI+8c9aHRM65SvVFngpVCjtdCOHMb9HhQQLa3WMbqyKUhuHkBsJvOSSr1fH2Wzr8nkSjqdz6+ziDz8HkH4D8WI+vj82n9cLpWOT07Pnra2L3cXlyhE9SpKoamHYxYHxzg3SqCJek+JFnT7oH9M2VBlkwfNzSd+8pqTg94X99w8JnJODlo9L7r5Bbz/Bl8CXdusuvkN6C2n3YFO9hnyupPbYdGaAp2eee57DvKKEm3q9uwcKI2GR/+nmPEOoZfBiPgYenCMjyCWYGpwmLDfjRRESpQ7YWcAAAAASUVORK5CYII=">
          <span>
            {{form.name}}
          </span>
        </div>
        <div class="pay__footer-money">
          <span>支付金额 : </span>
          <span>￥{{form.money}}</span>
        </div>
        <div v-loading="loading" class="pay__footer-menu"
             @click="$refs.form.submit()">
          确认订单
        </div>
      </div>
    </div>
    <el-dialog title="发票信息"
               top="40px"
               :close-on-click-modal="false"
               :close-on-press-escape="false"
               :show-close="false"
               :visible.sync="fpbox"
               class="pay__dialog"
               width="500px">
      <el-tag type="danger" style="margin-bottom: 10px;margin-left: 10px">若不需要发票,请填入公司或团队名,其他填横杠</el-tag>
      <!--<el-tag type="danger" style="margin-bottom: 10px;margin-left: 10px">提供正规增值税普通电子发票，在三十个工作日内通过邮箱发送,请耐心等待</el-tag>-->
      <el-tag type="danger" style="margin-bottom: 10px;margin-left: 10px">电子普通发票将在三十个工作日内开具，开票项目为：技术服务费</el-tag>
      <el-tag type="danger" style="margin-bottom: 10px;margin-left: 10px">提交后等待查收私服账号邮件,有疑问可联系官方邮箱:bladejava@qq.com</el-tag>
      <avue-form :option="fpoption"
                 v-model="fpform"
                 @submit="handleFpSubmit">
        <template slot="menuForm">
          <el-button  icon="el-icon-delete"  @click="handleEmpty">清 空</el-button>
        </template>
      </avue-form>
    </el-dialog>
    <el-dialog title="订单信息"
               top="40px"
               :close-on-click-modal="false"
               :visible.sync="box"
               class="pay__dialog"
               width="400px">
      <div class="header">
        <div class="tip">
          <img :src="imgsrc"
               width="60"
               alt="">
          <span class="text" :class="className">
            请使用{{text}}扫一扫<br>
            扫描二维码完成支付
          </span>
        </div>
        <p class="money">￥{{form.money}}</p>
        <img :src="payImg"
             class="code"
             alt=""/>
        <span style="padding-top: 10px" class="text"
              :class="className">
          请在5分钟内扫码付款
        </span>
        <p class="datetime"
           :class="className">
          <span v-for="(item,index) in datetimeList"
                :key="index">
            {{item}}
          </span>
        </p>
      </div>
      <div class="body">
        <p>产品名称: {{form.name}}</p>
        <p>订单单号: {{form.orderid}}</p>
        <p>下单时间: {{new Date(form.datetime).Format("yyyy-MM-dd hh:mm:ss")}}</p>
        <p>支付方式: {{text}}</p>
<!--        <p>Blade商业群 : <span style="color:#a6302d;cursor: pointer;" data-clipboard-text="748802498" class="c-group1" @click="copy('c-group1')">748802498</span></p>
        <p v-if="form.version===3">Avue商业群 : <span style="color:#a6302d;cursor: pointer;" data-clipboard-text="1043536271" class="c-group2" @click="copy('c-group2')">1043536271</span></p>
        <p>加群请备注: <span style="color:#a6302d;cursor: pointer;">{{form.qq}}</span></p>-->
        <p>资料发送至: <span style="color:#a6302d;cursor: pointer;">{{form.qq}}@qq.com</span></p>
      </div>
    </el-dialog>
    <el-dialog title="订单信息"
               top="40px"
               :close-on-click-modal="false"
               :visible.sync="cBox"
               class="pay__dialog"
               width="400px">
      <div class="header">
        <div class="tip">
          <img :src="imgsrc" width="60" alt="">
          <span class="text" style="color:#ce4e4b;cursor: pointer;">
            请使用{{text}}账户付款<br>
            支付完毕请提供凭证
          </span>
        </div>
        <p class="money">￥{{form.money}}</p>
      </div>
      <div class="cBody">
        <p>产品名称: {{form.name}}</p>
        <p>订单单号: {{form.orderid}}</p>
        <p>下单时间: {{new Date(form.datetime).Format("yyyy-MM-dd hh:mm:ss")}}</p>
        <p>支付方式: {{text}}</p>
        <p>=========对公账户=========</p>
        <p>账户名称: <span style="color:#a6302d;cursor: pointer;" data-clipboard-text="上海布雷德科技有限公司常州分公司" class="c-name" @click="copy('c-name')">上海布雷德科技有限公司常州分公司</span></p>
        <p>账户号码: <span style="color:#a6302d;cursor: pointer;" data-clipboard-text="479378943307" class="c-account" @click="copy('c-account')">479378943307</span></p>
        <p>开户银行: <span style="color:#a6302d;cursor: pointer;" data-clipboard-text="中国银行常州新北支行" class="c-address" @click="copy('c-address')">中国银行常州新北支行</span></p>
<!--        <p>账户名称: <span style="color:#a6302d;cursor: pointer;" data-clipboard-text="上海布雷德科技有限公司" class="c-name" @click="copy('c-name')">上海布雷德科技有限公司</span></p>
        <p>账户号码: <span style="color:#a6302d;cursor: pointer;" data-clipboard-text="445582751362" class="c-account" @click="copy('c-account')">445582751362</span></p>
        <p>开户银行: <span style="color:#a6302d;cursor: pointer;" data-clipboard-text="中国银行上海市大华支行" class="c-address" @click="copy('c-address')">中国银行上海市大华支行</span></p>-->
        <p>=========重点说明=========</p>
        <p>请把转账回执、授权QQ、公司名、税号整理完发送至 <span style="color:#a6302d;cursor: pointer;" data-clipboard-text="bladejava@qq.com" class="c-mail" @click="copy('c-mail')">bladejava@qq.com</span>，核对完便会把资料发送至授权QQ邮箱</p>
        <p>售前疑问请加商务微信 (<span style="color:#a6302d;cursor: pointer;" @click="openWX()">点击查看</span>)，或者发邮件 (<span style="color:#a6302d;cursor: pointer;" data-clipboard-text="bladejava@qq.com" class="c-mail" @click="copy('c-mail')">bladejava@qq.com</span>) 沟通</p>
        <p>若付款 24小时 后无回应请拨打我们的电话：<span style="color:#a6302d;cursor: pointer;" data-clipboard-text="18961277632" class="c-phone" @click="copy('c-phone')">18961277632</span>，此电话仅作为授权开通使用，不用于售前咨询，请见谅</p>
      </div>
    </el-dialog>
    <el-dialog title="商务微信"
               :visible.sync="wxBox"
               width="450px">
      <div>
        <img src="/images/wx.png" width="100%" alt="">
      </div>
    </el-dialog>
    <el-dialog :visible.sync="box1" title="专业版授权说明" width="50%">
      <el-tabs>
        <el-tab-pane label="权益说明">
          <el-alert type="info">
            购买请先阅读↑️问题解答↑️，若有购买上的疑问请加↑商务微信↑，或者发邮件(bladejava@qq.com)，备注BladeX授权咨询，非诚勿扰哦～
          </el-alert>
          <el-alert type="info">
            付款完成后，请用填写的授权QQ加商业群(748802498)并耐心等待，我们会及时通过并开通git账号权限，git账号为填写的QQ号
          </el-alert>
          <el-alert
            title="专业版￥999，只可用于个人学习及个人私活项目，不可用于公司或团队，不可泄露给任何第三方"
            type="error">
          </el-alert>
          <el-alert
            title="若甲方需要您提供项目源码，则需代为甲方购买BladeX企业授权，甲方购买后续的所有项目都无需再次购买授权"
            type="error">
          </el-alert>
          <el-alert
            title="应用市场的产品由第三方提交审核后上架销售，不包含在BladeX核心授权内，若有需要可前往选购"
            type="info">
          </el-alert>
          <el-alert
            title="BladeX系列框架源码（BladeX、BladeX-Tool、BladeX-Boot、BladeX-Biz、Saber等）"
            type="success">
          </el-alert>
          <el-alert
            title="享受BladeX系列框架开发计划内的永久免费更新、不限制服务器数、不限制项目数"
            type="success">
          </el-alert>
          <el-alert
            title="可参加BladeX插件定制的众筹活动"
            type="success">
          </el-alert>
          <el-alert
            title="BladeX全系列文档均免费赠送"
            type="success">
          </el-alert>
          <el-alert
            title="1个进入BladeX会员群的名额"
            type="warning">
          </el-alert>
          <el-alert
            title="会员群：748802498"
            type="warning">
          </el-alert>
        </el-tab-pane>
        <el-tab-pane label="问题解答">
          <el-alert title="问：开源版与商业版有什么区别？" type="error"></el-alert>
          <el-alert title="答：商业版对开源版做了全面增强，提供了非常多企业级所需的功能，可以开箱即用，提高开发效率，降低人力成本。" type="success"></el-alert>
          <el-alert title="问：如何购买，如何获取商业源码?" type="error"></el-alert>
          <el-alert title="答：在购买页面填写授权QQ，并下单扫码付款，付款成功后授权信息会以邮件的形式发送到填写的QQ对应邮箱。" type="success"></el-alert>
          <el-alert title="问：系统支持IE浏览器么?" type="error"></el-alert>
          <el-alert title="答：我们系统由于底层组件不支持IE，所以也没有办法对IE浏览器进行支持了。" type="success"></el-alert>
          <el-alert title="问：购买授权后所获取的源码都是开放的吗？会不会有后门？" type="error"></el-alert>
          <el-alert title="答：购买授权获取的源码均开放，没有混淆加密，没有后门，可放心使用。" type="success"></el-alert>
          <el-alert title="问：提供的源码是压缩包么？后期可以获取免费更新么？" type="error"></el-alert>
          <el-alert title="答：源码托管在Git私服，可随时下载最新版本。授权下的项目都可以免费更新，并可查看Git提交记录，分析每一次更新的具体内容。" type="success"></el-alert>
          <el-alert title="问：获取源码后不想用了，可以退款么？" type="error"></el-alert>
          <el-alert title="答：我们提供的是全部源码，源码具有可复制性，所以一旦售出不支持退款，还请谅解。" type="success"></el-alert>
          <el-alert title="问：个人名义购买后可不可以和朋友一起做私活？" type="error"></el-alert>
          <el-alert title="答：购买授权后不限制项目和服务器，但是个人名义，不可以和其他人共同使用。若需团队开发，请以企业名义注册授权。" type="success"></el-alert>
          <el-alert title="问：有没有技术支持，遇到问题了怎么办？" type="error"></el-alert>
          <el-alert title="答：购买授权后有一个名额进入商业群进行答疑，复杂问题也可以发到技术社区进行提问。不过没有一对一的实时私人技术支持，请谅解。" type="success"></el-alert>
          <el-alert title="问：如果需要一对一的技术支持，如何操作？" type="error"></el-alert>
          <el-alert title="答：看文档以及在商业群、社区提问能解决绝大多数问题。若还需要一对一技术支持，可以考虑另外付费，技术顾问市场价在2k-3k每天。" type="success"></el-alert>
          <el-alert title="问：基于BladeX开发的产品是否可以申请软著？" type="error"></el-alert>
          <el-alert title="答：专业版只可用于自学及私活，若需要申请软著请购买企业版授权。" type="success"></el-alert>
          <el-alert title="问：基于BladeX开发的产品对外销售，有没有什么限制？" type="error"></el-alert>
          <el-alert title="答：专业版只可用于自学及私活，不可以开发产品销售，若需要做为产品，请购买企业版授权。另外如果给甲方做的私活需要提供源码，则需要为甲方购买一份企业版授权。"
                    type="success"></el-alert>
          <el-alert title="问：为何给客户提供了源码就需要再次购买授权，不是已经买过了么？" type="error"></el-alert>
          <el-alert
            title="答：专业版授权以个人为一个主体，客户属于另一个主体，若客户拿到了源码，则需要购买一次授权。购买授权后，这家客户后续的所有项目都无需再购买授权了，也就是说，一个主体只需购买一次授权。若A单位购买了授权，将源码泄露给没有购买授权的B单位，哪怕两者有生意往来也是不行的，否则这就成为了盗版漏洞。比如有人购买一次授权，若没有授权单位的限制，他就可以在网上超低价销售源码给任何人，对外声称购买源码的人都是自己的客户，这会对作者以及正版用户带来巨大损失，所以这种盗版行为肯定是不被允许的。"
            type="success"></el-alert>
          <el-alert title="问：盗版侵权，有没有什么严重后果？" type="error"></el-alert>
          <el-alert
            title="答：盗版的源码不是从官方获取，会有可能被人植入后门，给项目带来严重隐患。盗版使用者是没法获得官方技术支持的，版本遗留的bug无法更新，使用碰到问题无法获得解决，光这一块就会耗费大量精力，付出的代价甚至会比购买授权高很多。盗版行为不受法律保护，如果情节严重，版权方起诉侵犯软件著作权，盗版发布者和盗版使用者几乎没可能胜诉，一旦留下案底将影响自己的大好前程，也将影响自己未来子女的前途。盗版百害无一益，一定慎重，否则一旦出事，将无法挽回。"
            type="success"></el-alert>
        </el-tab-pane>
        <el-tab-pane label="软著证书">
          <img src="/images/cert.jpg" width="100%" alt="">
        </el-tab-pane>
        <el-tab-pane label="商务微信">
          <img src="/images/wx.png" width="100%" alt="">
        </el-tab-pane>
      </el-tabs>
    </el-dialog>


    <el-dialog :visible.sync="box2" title="商业授权说明" width="50%">
      <el-tabs>
        <el-tab-pane label="权益说明">
          <el-alert type="info">
            购买请先阅读↑️问题解答↑️，若有购买上的疑问请加↑商务微信↑，或者发邮件(bladejava@qq.com)，备注BladeX授权咨询，非诚勿扰哦～
          </el-alert>
          <el-alert type="info">
            付款完成后，请用填写的授权QQ加商业群(748802498)并耐心等待，我们会及时通过并开通git账号权限，git账号为填写的QQ号
          </el-alert>
          <el-alert type="info">
            由于源码具有可复制性，若登录git获取了源码，则不支持退款，还请理解
          </el-alert>
          <el-alert
            title="BladeX数据大屏版￥5999，BladeX企业版￥5000，BladeX联合版￥8999，提供增值税普通电子普票，报价已含税"
            type="error">
          </el-alert>
          <el-alert
            title="BladeX物联网平台￥8999，若已购大屏、企业版、联合版则可额外优惠￥1000，提供增值税普通电子普票，报价已含税"
            type="error">
          </el-alert>
          <el-alert
            title="若甲方需要您提供项目源码，则需代为甲方购买BladeX企业授权，甲方购买后续的所有项目都无需再次购买授权"
            type="error">
          </el-alert>
          <el-alert
            title="企业版员工只授权开发所在授权企业名下的项目，不得将BladeX用于个人私活"
            type="error">
          </el-alert>
          <el-alert
            title="购买后若未提供授权主体，则无法激活代码更新权益，也仅可一个人学习，不可提供源码给第二人，不可商用"
            type="warning">
          </el-alert>
          <el-alert
            title="绑定授权主体后便可开通代码更新权益。若使用期间将源码提供给未授权的第三方，将会取消授权，情节严重将追究违约责任"
            type="warning">
          </el-alert>
          <el-alert
            title="绑定授权主体后不论何种原因均不可变更成其他主体，也不可将源码提供给未授权的第三方"
            type="warning">
          </el-alert>
          <el-alert
            title="应用市场的产品由第三方提交审核后上架销售，并非BladeX官方开发，不包含在BladeX核心授权内，若有需要可前往选购"
            type="info">
          </el-alert>
          <el-alert
            title="允许授权企业将BladeX系列框架用于合法商业用途，不限项目数，不限服务器数"
            type="info">
          </el-alert>
          <el-alert
            title="我们提供正规增值税普通电子普票，在三十个工作日内通过邮箱发送，开票项目为：技术服务费，请耐心等待"
            type="info">
          </el-alert>
          <el-alert
            title="提供BladeX商业授权书电子版，邮件发送，届时根据邮件记录与授权号进行防伪"
            type="info">
          </el-alert>
          <el-alert
            title="BladeX系列框架源码（BladeX、BladeX-Tool、BladeX-Boot、BladeX-Biz、Saber等）"
            type="success">
          </el-alert>
          <el-alert
            title="享受BladeX系列框架开发计划内的永久免费更新、不限制服务器数、不限制项目数"
            type="success">
          </el-alert>
          <el-alert
            title="可参加BladeX插件定制的众筹活动"
            type="success">
          </el-alert>
          <el-alert
            title="BladeX全系列文档均免费赠送"
            type="success">
          </el-alert>
          <el-alert
            title="1个进入BladeX会员群的名额"
            type="warning">
          </el-alert>
          <el-alert
            title="会员群与sns问答社区优先解答使用问题"
            type="warning">
          </el-alert>
          <el-alert
            title="会员群：748802498"
            type="warning">
          </el-alert>
        </el-tab-pane>
        <el-tab-pane label="问题解答">
          <el-alert title="问：开源版与商业版有什么区别？" type="error"></el-alert>
          <el-alert title="答：商业版对开源版做了全面增强，提供了非常多企业级所需的功能，可以开箱即用，提高开发效率，降低人力成本。" type="success"></el-alert>
          <el-alert title="问：如何购买，如何获取商业源码，发票怎么开?" type="error"></el-alert>
          <el-alert title="答：在购买页面填写授权QQ，并下单扫码付款，付款成功后会有发票界面弹出填写，授权信息会以邮件的形式发送到填写的QQ对应邮箱。" type="success"></el-alert>
          <el-alert title="问：系统支持IE浏览器么?" type="error"></el-alert>
          <el-alert title="答：我们系统由于底层组件不支持IE，所以也没有办法对IE浏览器进行支持了。" type="success"></el-alert>
          <el-alert title="问：购买授权后所获取的源码都是开放的吗？会不会有后门？" type="error"></el-alert>
          <el-alert title="答：购买授权获取的源码均开放，没有混淆加密，没有后门，可放心使用。" type="success"></el-alert>
          <el-alert title="问：提供的源码是压缩包么？后期可以获取免费更新么？" type="error"></el-alert>
          <el-alert title="答：源码托管在Git私服，可随时下载最新版本。授权下的项目都可以免费更新，并可查看Git提交记录，分析每一次更新的具体内容。" type="success"></el-alert>
          <el-alert title="问：获取源码后不想用了，可以退款么？" type="error"></el-alert>
          <el-alert title="答：我们提供的是全部源码，源码具有可复制性，所以一旦售出不支持退款，还请谅解。" type="success"></el-alert>
          <el-alert title="问：个人名义购买后可不可以和朋友一起做私活？" type="error"></el-alert>
          <el-alert title="答：购买授权后不限制项目和服务器，但是个人名义，不可以和其他人共同使用。若需团队开发，请以企业名义注册授权。" type="success"></el-alert>
          <el-alert title="问：有没有技术支持，遇到问题了怎么办？" type="error"></el-alert>
          <el-alert title="答：购买授权后有一个名额进入商业群进行答疑，复杂问题也可以发到技术社区进行提问。不过没有一对一的实时私人技术支持，请谅解。" type="success"></el-alert>
          <el-alert title="问：如果需要一对一的技术支持，如何操作？" type="error"></el-alert>
          <el-alert title="答：看文档以及在商业群、社区提问能解决绝大多数问题。若还需要一对一技术支持，可以考虑另外付费，技术顾问市场价在2k-3k每天。" type="success"></el-alert>
          <el-alert title="问：基于BladeX开发的产品是否可以申请软著？" type="error"></el-alert>
          <el-alert title="答：可以用自己开发的业务代码申请软著，但不可以用BladeX核心源码申请软著。" type="success"></el-alert>
          <el-alert title="问：基于BladeX开发的产品对外销售，有没有什么限制？" type="error"></el-alert>
          <el-alert title="答：若对外销售的是服务，客户拿不到源码只使用系统，则没有限制。若对外销售带有源码，则需为客户购买一份企业授权，否则不可提供源码。" type="success"></el-alert>
          <el-alert title="问：为何给客户提供了源码就需要再次购买授权，不是已经买过了么？" type="error"></el-alert>
          <el-alert
            title="答：企业版授权以公司为一个主体，客户属于另一个主体，若客户拿到了源码，则需要购买一次授权。购买授权后，这家客户后续的所有项目都无需再购买授权了，也就是说，一个主体只需购买一次授权。若A单位购买了授权，将源码泄露给没有购买授权的B单位，哪怕两者有生意往来也是不行的，否则这就成为了盗版漏洞。比如有人购买一次授权，若没有授权单位的限制，他就可以在网上超低价销售源码给任何人，对外声称购买源码的人都是自己的客户，这会对作者以及正版用户带来巨大损失，所以这种盗版行为肯定是不被允许的。"
            type="success"></el-alert>
          <el-alert title="问：盗版侵权，有没有什么严重后果？" type="error"></el-alert>
          <el-alert
            title="答：盗版的源码不是从官方获取，会有可能被人植入后门，给项目带来严重隐患。盗版使用者是没法获得官方技术支持的，版本遗留的bug无法更新，使用碰到问题无法获得解决，光这一块就会耗费大量精力，付出的代价甚至会比购买授权高很多。盗版行为不受法律保护，如果情节严重，版权方起诉侵犯软件著作权，盗版发布者和盗版使用者几乎没可能胜诉，一旦留下案底将影响自己的大好前程，也将影响自己未来子女的前途。盗版百害无一益，一定慎重，否则一旦出事，将无法挽回。"
            type="success"></el-alert>
        </el-tab-pane>
        <el-tab-pane label="软著证书">
          <img src="/images/cert.jpg" width="100%" alt="">
        </el-tab-pane>
        <el-tab-pane label="商务微信">
          <img src="/images/wx.png" width="100%" alt="">
        </el-tab-pane>
      </el-tabs>
    </el-dialog>
    <div id="qrcode"
         style="display:none"
         ref="qrcode"></div>
  </div>

</template>

<script>
  import {config, payList} from '../const/config'
  import {Encrypt} from '../util/crypto';
  import Clipboard from 'clipboard';
  import Record from '@/util/record';
  import {mapState} from "vuex";

  const prefixCls = "pay";

  var validateQQ = (rule, value, callback) => {
    if (value.length < 5) {
      callback(new Error('QQ号不正确'));
    } else {
      callback();
    }
  };
  export default {
    data() {
      return {
        config: config,
        loading: false,
        img: '',
        payImg: '/images/loading.gif',
        box1: false,
        box2: false,
        fpbox: false,
        datetime: '',
        datecheck: null,
        ordercheck: null,
        fpform: {},
        fpoption: {
          emptyBtn: false,
          column: [{
            label: '订单号',
            prop: 'orderid',
            disabled: true,
            span: 24
          }, {
            label: '公司名称',
            prop: 'mc',
            rules: [{
              required: true,
              message: "请输入公司名称",
              trigger: "blur"
            }],
            span: 24
          }, {
            label: '公司税号',
            prop: 'sh',
            rules: [{
              required: true,
              message: "请输入公司税号",
              trigger: "blur"
            }],
            span: 24
          }
            /*, {
              label: '收件人',
              prop: 'sjr',
              span: 24
            }, {
              label: '联系方式',
              span: 24,
              prop: 'lxfs',
            }, {
              label: '收件地址',
              prop: 'sjdz',
              type: 'textarea',
              span: 24
            }*/
            , {
              label: '备注',
              prop: 'bz',
              span: 24
            }]
        },
        box: false,
        cBox: false,
        wxBox: false,
        list: config,
        id: '',
        form: {
          orderid: '',
          datetime: '',
          day: 0,
          type: 2,
          qq: '',
          flag: false,
        },
        option: {
          menuPostion: 'left',
          emptyBtn: false,
          submitBtn: false,
          column: [{
            label: '',
            labelWidth: 1,
            formslot: true,
            row: true,
            prop: 'default'
          }, {
            label: '产品名称',
            formslot: true,
            row: true,
            prop: 'name'
          }, {
            label: '产品类型',
            type: 'radio',
            border: true,
            formslot: true,
            dicData: config,
            span: 24,
            row: true,
            prop: 'version'
          }, {
            label: '授权期限',
            type: 'radio',
            border: true,
            display: false,
            dicData: [{
              label: '永久',
              value: 0
            }],
            row: true,
            prop: 'day'
          }, {
            label: '授权须知',
            formslot: true,
            row: true,
            prop: 'defaults'
          }, {
            label: '',
            formslot: true,
            labelWidth: 1,
            row: true,
            prop: 'money'
          }, {
            label: '支付方式',
            type: 'radio',
            border: true,
            dicData: payList,
            formslot: true,
            row: true,
            prop: 'type'
          }, {
            label: '发票类型',
            formslot: true,
            row: true,
            prop: 'tickets'
          }, {
            label: '联系官方',
            formslot: true,
            row: true,
            prop: 'contact'
          }, {
            label: '授权QQ',
            span: 7,
            row: true,
            rules: [{
              required: true,
              message: "请输入授权QQ",
              trigger: "blur"
            },
              {
                validator: validateQQ,
                trigger: 'blur'
              }],
            prop: 'qq'
          }, {
            label: '购买说明',
            formslot: true,
            row: true,
            prop: 'introduction'
          }]
        }
      }
    },
    watch: {
      $route() {
        this.init();
      },
      'box'(val) {
        if (!val) {
          clearInterval(this.ordercheck);
          clearInterval(this.datecheck);
        }
      },
      'form.version': {
        handler(val) {
          if (this.form.version === 0 || this.form.version === 2) {
            this.form.type = 1;
          }
          const obj = config.filter(ele => ele.value === val)[0];
          this.form.name = obj.label;
          this.form.money = obj.money;
          this.$router.push({
            path: '/pay',
            query: {
              version: val
            }
          })
        }
      }
    },
    created() {
      this.init();

      setTimeout(() => {
        this.notice = this.$notify.success({
          title: "BladeX 新产品通知",
          dangerouslyUseHTMLString: true,
          message: `
        <p>----------------------------</p>
        <p>《BladeXAI大模型平台》正式发售通知</p>
        <p>----------------------------</p>
        <p>1.「三位一体」智能架构提供灵活的 Chat、Agent、RAG 模式，满足不同业务需求，让智能化升级触手可及。</p>
        <p>2. 老用户购买额外优惠：￥2,000元。</p>
        <p>3. 系统演示：<a target="_blank" href="https://aigc.bladex.cn/">查看演示</a></p>
        <p>4. 官网地址：很快到来，敬请期待。</p>
        <p>5. 商务联系：<a target="_blank" href="https://bladex.cn/#/contract">点击查看</a></p>
        <p>----------------------------</p>
        <p>《BladeX物联网平台》正式发售通知</p>
        <p>----------------------------</p>
        <p>1.「纯自研MQTT」「EMQX+Kafka」双架构，支持单机与集群双模式切换，满足不同业务场景，助力万物互联。</p>
        <p>2. 老用户购买额外优惠：￥2,000元。</p>
        <p>3. 系统演示：<a target="_blank" href="https://iot.javablade.com/">查看演示</a></p>
        <p>4. 官网地址：<a target="_blank" href="https://iot.bladex.cn/">查看官网</a></p>
        <p>5. 商务联系：<a target="_blank" href="https://bladex.cn/#/contract">点击查看</a></p>
        <p>----------------------------</p>`,
          duration: 0,
          offset: 50,
          position: 'bottom-right',
          type: "success"
        });
      }, 500);
    },
    destroyed() {
      this.notice.close();
    },
    mounted() {

    },
    computed: {
      datetimeList() {
        return this.datetime.split('')
      },
      className() {
        return this.form.type === 2 ? `${prefixCls}--bule` : `${prefixCls}--green`
      },
      btncolor() {
        return this.form.type === 2 ? 'primary' : 'success'
      },
      imgsrc() {
        return this.form.type === 2 ? '/images/zgyhicon.png' : ' /images/wxicon.png'
      },
      text() {
        return this.form.type === 2 ? '对公' : '微信'
      },
      ...mapState(['user']),
    },
    methods: {
      copy(className) {
        let clipboard = new Clipboard('.' + className);
        clipboard.on('success', e => {
          window.console.log(e);
          this.$message.success('复制成功');
          // 释放内存
          clipboard.destroy();
        });
        clipboard.on('error', e => {
          // 不支持复制
          window.console.log(e);
          this.$message.success('复制失败，请用其他浏览器尝试');
          // 释放内存
          clipboard.destroy()
        })
      },
      openTicket() {
        this.$message.success('官网报价对应的都是增值税普通电子发票哦');
      },
      openWX() {
        this.wxBox = true;
      },
      isCompany() {
        return this.form.type === 2;
      },
      handleEmpty(){
        this.fpform.mc = '';
        this.fpform.sh = '';
        this.fpform.bz = '';
      },
      handleSelect(item) {
        if (item.href) {
          window.location.href = item.href;
          return
        }
        this.form.version = item.value;
      },
      init() {
        this.form.version = Number(this.$route.query.version)
        if (!this.form.version) this.form.version = 0
      },
      insert(data, table) {
        const query = new Record(table || 'x_order');
        const entity = {};
        Object.keys(data).forEach(ele => {
          if (ele.includes('$')) {
            entity[ele.replace('$', '') + '_text'] = data[ele];
          } else {
            entity[ele] = data[ele];
          }
        });
        query.entity(entity);
        return query.save()
      },
      update(id, data, table) {
        const form = this.deepClone(data);
        const query = new Record(table || 'x_order');
        const entity = {};
        entity['id'] = id;
        delete form.createdAt;
        delete form.updatedAt;
        delete form.objectId;
        delete form.key;
        delete form.introduction;
        delete form.tickets;
        delete form.contact;
        Object.keys(form).forEach(ele => {
          if (form[ele]) {
            entity[ele] = form[ele]
          }

        })
        query.entity(entity);
        return query.update()
      },
      dingPush() {
        this.$httpajax.post('https://payment.javablade.com/api/robot/send', {
          tenant: 1,
          title: this.form.$version + '订单信息',
          list: [{
            label: "订单号",
            value: this.form.orderid
          }, {
            label: "用户QQ",
            value: this.form.qq
          }, {
            label: "套餐类型",
            value: this.form.$version,
          }, {
            label: "支付金额",
            value: this.form.money
          }, {
            label: "支付方式",
            value: this.form.$type
          }]
        })
      },
      tradeNo() {
        const now = new Date()
        const year = now.getFullYear();
        let month = now.getMonth() + 1;
        let day = now.getDate();
        let hour = now.getHours();
        let minutes = now.getMinutes();
        let seconds = now.getSeconds();
        String(month).length < 2 ? (month = "0" + month) : month;
        String(day).length < 2 ? (day = "0" + day) : day;
        String(hour).length < 2 ? (hour = "0" + hour) : hour;
        String(minutes).length < 2 ? (minutes = "0" + minutes) : minutes;
        String(seconds).length < 2 ? (seconds = "0" + seconds) : seconds;
        const yyyyMMddHHmmss = `${year}${month}${day}${hour}${minutes}${seconds}`;
        this.id = Math.random().toString(36).substr(2, 6);
        return yyyyMMddHHmmss + '_' + this.id
      },
      handleBox() {
        if (this.form.version === 0) {
          this.box1 = true;
        } else {
          this.box2 = true;
        }
      },
      handleFpSubmit(form, done) {
        this.fpform.flag = false;
        this.fpform.datetime = (new Date()).Format('yyyy-MM-dd hh:mm:ss');
        this.$confirm(`确认提交发票信息，一经提交无法修改？`, '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning'
        }).then(() => {
          this.insert(this.fpform, 'x_ticket').then(() => {
            this.fpbox = false;
            this.$message.success('发票提交成功');
            this.msgtip();

            this.$httpajax.post('https://payment.javablade.com/api/robot/send', {
              title: '发票信息',
              list: [{
                label: "订单号",
                value: this.form.orderid || '-'
              }, {
                label: "授权QQ",
                value: this.form.qq || '-'
              }, {
                label: "公司名称",
                value: this.fpform.mc || '-'
              }, {
                label: "公司税号",
                value: this.fpform.sh || '-'
              }]
            });

            done();
          })
        }).catch(() => {
          done();
        })
      },
      queryOrderid() {
        clearInterval(this.ordercheck);
        this.ordercheck = setInterval(() => {
          const query = new Record('x_order')
          query.equalTo("orderid", "=", `'${this.form.orderid}'`);
          query.find().then(res => {
            const flag = res.data[0].flag;
            if (flag === true) {
              this.box = false;
              if ([1, 2, 3, 5].includes(this.form.version)) {
                this.fpbox = true;
              } else {
                this.msgtip();
              }
              if (this.box === false) {
                clearInterval(this.ordercheck);
                clearInterval(this.datecheck);
              }
            }
          });
        }, 1000);
      },
      msgtip() {
        this.$alert(`相关资料将发送至${this.form.qq}@qq.com邮箱请注意查收`, '提示', {
          confirmButtonText: '确定',
          callback: () => {
            //this.$store.commit('setUser', this.form.qq)
            //this.$router.push('/user/auth')
          }
        });
      },
      queryTime() {
        this.datetime = "05:00";
        var maxtime = 5 * 60 - 1; //
        const CountDown = () => {
          if (maxtime >= 0) {
            this.update(this.form.objectId, {
              datetime: new Date((new Date().getTime() - 1000 * 20)).Format('yyyy-MM-dd hh:mm:ss')
            })
            var minutes = Math.floor(maxtime / 60);
            var seconds = Math.floor(maxtime % 60);
            if (minutes < 10) minutes = '0' + minutes
            if (seconds < 10) seconds = '0' + seconds
            this.datetime = minutes + ":" + seconds
            --maxtime;
          } else {
            this.box = false;
            clearInterval(this.datecheck);
          }
        };
        clearInterval(this.datecheck);
        this.datecheck = setInterval(() => CountDown(), 1000);
      },
      loadPayImg() {
        this.payImg = "/images/loading.gif";
        const datetime = new Date().Format('yyyyMMddhhmmss');
        this.$httpajax.post(this.website.PAY.url, Object.assign(this.form, {key: Encrypt(datetime)})).then(resp => {
          if (resp.data.code === "200") {
            this.payImg = resp.data.data;
          } else {
            this.$message.error("网络繁忙，请稍后再试。");
          }
        });

      },
      handleSubmit(form, done) {
        done();
        this.form.qq = this.form.qq.trim();
        let numReg = /^[0-9]+$/;
        let numRe = new RegExp(numReg);
        if (this.user !== 'bladex' && !numRe.test(this.form.qq)) {
          this.$message.error('请输入正确的qq号！');
          return false;
        }
        this.loading = true;
        const query = new Record('x_order');
        query.equalTo("qq", "=", `'${this.form.qq}'`);
        query.equalTo("type", "=", this.form.type);
        query.equalTo("version", "=", this.form.version);
        query.equalTo("flag", "=", false);
        query.find().then(res => {
          if (this.validatenull(res.data[0])) {
            this.form.orderid = this.tradeNo();
            this.fpform.orderid = this.form.orderid;
            this.form.datetime = (new Date()).Format('yyyy-MM-dd hh:mm:ss');
            if (this.form.qq.indexOf("@qq.com") > 0) {
              this.form.qq = this.form.qq.replace("@qq.com", "");
            }
            let data = this.deepClone(this.form)
            delete data.objectId;
            delete data.createdAt;
            delete data.updatedAt;
            delete data.key;
            delete data.introduction;
            delete data.tickets;
            delete data.contact;
            delete data.default;
            delete data.defaults;
            // 自定义订单设置价格为0
            if (data.qq === '85088620') {
              data.money = 0;
            }
            // 联合版和大屏版修改真实价格
            if (data.version === 3) {
              data.money = 5500;
            }
            if (data.version === 5) {
              data.money = 2999;
            }
            if (data.version === 6) {
              data.money = 5600;
            }
            if (data.version === 8) {
              data.money = 5000;
            }
            if (data.version === 9) {
              data.money = 10000;
            }
            if (data.version === 10) {
              data.money = 16000;
            }
            this.insert(data).then((res) => {
              this.form.objectId = res.data;
              this.dingPush();
              if (this.isCompany()) {
                this.cBox = true;
              } else {
                this.box = true;
                this.loadPayImg();
                this.queryOrderid();
                this.queryTime();
              }
              done();
              this.loading = false;
            });
          } else {
            let data = res.data[0];
            // 如果是联合版，则改回总体价格
            if (data.version === 3) {
              data.money = config[4].money;
            }
            if (data.version === 5) {
              data.money = config[1].money;
            }
            if (data.version === 6) {
              data.money = config[2].money;
            }
            if (data.version === 8) {
              data.money = config[3].money;
            }
            if (data.version === 9) {
              data.money = config[5].money;
            }
            if (data.version === 10) {
              data.money = config[6].money;
            }
            this.form = data;
            // 更新下单时间
            this.update(this.form.objectId, {
              datetime: (new Date()).Format('yyyy-MM-dd hh:mm:ss')
            });
            this.fpform.orderid = this.form.orderid;
            this.id = this.form.orderid.split("_")[1];
            if (this.isCompany()) {
              this.cBox = true;
            } else {
              this.box = true;
              this.loadPayImg();
              this.queryOrderid();
              this.queryTime();
            }
            done();
            this.loading = false;
          }
        });


      }
    }
  }
</script>

<style lang="scss">
  .pay {
    height: 700px;

    &__footer {
      width: 100%;
      background: #fff;
      box-shadow: 0 -1px 0 0 hsla(0, 0%, 71%, 0.18);
      position: fixed;
      left: 0;
      bottom: 0;

      &-box {
        display: flex;
        justify-content: space-between;
        align-items: center;
        padding: 0 20px;
        max-width: 1200px;
        width: 100%; // 确保在小屏幕上宽度自适应
        margin: 0 auto;
      }

      &-menu {
        min-width: 135px; // 设置最小宽度而非固定宽度
        margin: 10px 20px; // 使用padding增加按钮的点击区域和视觉效果
        line-height: 44px;
        background: #3369ff;
        font-size: 14px;
        font-weight: 700;
        text-align: center;
        color: #fff;
        cursor: pointer;
        user-select: none;
        border-radius: 24px;
      }

      &-money, &-name {
        text-align: center; // 确保文本在所有屏幕尺寸下都居中显示
      }

      &-money {
        span {
          &:first-child {
            font-size: 12px;
            color: #545454;
            font-weight: 700;
          }

          &:nth-child(2) {
            margin-left: 9px;
            font-size: 22px;
            color: #3369ff;
            font-weight: 700;
            height: 28px;
          }
        }
      }

      &-name {

        span {
          color: #545454;
          font-weight: 700;
          font-size: 14px;
          margin-left: 20px;
          width: 80%;
          overflow: hidden;
          white-space: nowrap;
          text-overflow: ellipsis;
        }
      }
    }

    @media (max-width: 768px) {
      &__footer-box {
        flex-direction: column;
        align-items: center; // 在小屏幕上垂直居中对齐所有子元素
      }

      &-menu {
        width: 100%; // 小屏幕上按钮宽度调整为100%
        margin-top: 10px;
        padding: 10px 0; // 调整padding以适应宽度变化
      }

      &-money, &-name {
        width: 100%; // 确保在小屏幕上元素宽度调整为100%
        margin-top: 10px;
      }
    }


    &__title {
      display: flex;
      align-items: center;

      img {
        margin-right: 10px;
      }

      span {
        margin-bottom: 2px;
        color: #545454;
        font-size: 16px;
        font-weight: 700;
        margin-left: 3px;
      }
    }

    &__item {
      display: inline-block;
      vertical-align: middle;
      height: 84px;
      min-width: 182px;
      padding-left: 18px;
      padding-right: 26px;
      background: #fff;
      border: 2px solid #f1f4fb;
      box-shadow: 0 4px 10px 0 rgba(135, 142, 154, 0.14);
      border-radius: 10px;
      margin-right: 11px;
      margin-bottom: 10px;
      cursor: pointer;
      user-select: none;
      position: relative;
      line-height: 1.5;

      &-name {
        color: #545454;
        font-size: 14px;
        font-weight: 400;
        margin-top: 16px;
        margin-bottom: 5px;
      }

      &-img {
        position: absolute;
        right: -1px;
        bottom: -1px;
        border-radius: 0 0 10px 0;
      }

      &-money {
        color: #3369ff;
        font-size: 14px;
        font-weight: 700;
      }

      &-detail {
        text-align: right;
        color: #0db26a;
        font-size: 12px;
      }

      &--active {
        color: #3369ff;
        border: 2px solid #3369ff;

        .pay__item-name {
          color: #3369ff;
        }
      }

      &--disabled {
        color: #c0c4cc;

        .pay__item-name,
        .pay__item-money,
        .pay__item-detail {
          color: #c0c4cc;
        }
      }
    }

    &__content {
      margin: 20px auto 0 auto;
      width: 1200px;
    }

    &__name {
      font-size: 18px;
      font-weight: 600;
      color: #000;
    }

    &--green {
      border-color: #5ac33c;
      color: #5ac33c;
    }

    &--bule {
      border-color: #48a9e9;
      color: #48a9e9;
    }

    &__dialog {
      .el-dialog__body {
        padding: 0;
      }

      .header {
        text-align: center;
      }

      .money {
        color: #000;
        font-size: 42px;
        font-weight: 500;
        margin-bottom: 10px;
      }

      .datetime {
        font-size: 30px;
        font-weight: bold;

        span {
          text-align: center;
          width: 25px;
          display: inline-block;
          margin: 0 3px;
        }
      }

      .code {
        display: block;
        margin: 10px auto 5px auto;
        width: 180px;
      }

      .body {
        color: #000;
        margin: 0 auto;
        width: 240px;
        padding: 30px 0;

        p {
          font-size: 14px;
          line-height: 25px;
        }
      }

      .cBody {
        color: #000;
        margin: 0 auto;
        width: 240px;
        padding: 0 0 30px 0;

        p {
          font-size: 14px;
          line-height: 25px;
        }
      }

      .tip {
        display: flex;
        align-items: center;
        justify-content: center;

        .text {
          font-weight: 500;
          display: inline-block;
          vertical-align: middle;
          text-align: left;
          margin-left: 15px;
          font-size: 16px;
          line-height: 28px;
        }
      }
    }

    &__money {
      font-size: 26px;
      color: #ff5722;
    }
  }

  .el-form-item {
    margin-bottom : 18px;
  }
</style>
